import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '@/contexts/LanguageContext';

export function CreateFAB() {
  const navigate = useNavigate();
  const location = useLocation();
  const { language } = useLanguage();
  const [showLabel, setShowLabel] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShowLabel(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  const showOnPaths = ['/', '/track', '/account'];
  if (!showOnPaths.includes(location.pathname)) return null;

  return (
    <div dir="ltr" className="fixed bottom-20 right-4 md:hidden z-50 flex items-center gap-2">
      <AnimatePresence>
        {showLabel && (
          <motion.div
            initial={{ opacity: 0, x: 10 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 10 }}
            transition={{ duration: 0.3 }}
            className="bg-card text-card-foreground text-xs font-medium px-3 py-1.5 rounded-full shadow-md border border-border whitespace-nowrap relative"
          >
            <span dir="auto">{language === 'fa' ? 'شروع ساخت!' : 'Start Creating!'}</span>
            <span className="absolute top-1/2 -translate-y-1/2 -right-1 w-2 h-2 bg-card border-r border-b border-border rotate-[-45deg]" />
          </motion.div>
        )}
      </AnimatePresence>

      <motion.button
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ type: 'spring', stiffness: 400, damping: 15, delay: 0.2 }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        onClick={() => navigate('/toy?new=true')}
        className="w-14 h-14 rounded-full bg-gradient-to-br from-primary to-primary-dark text-primary-foreground shadow-lg flex items-center justify-center"
        aria-label={language === 'fa' ? 'شروع ساخت اسباب‌بازی' : 'Start creating a toy'}
      >
        <Sparkles size={24} />
      </motion.button>
    </div>
  );
}
